import { useDictationStore } from '@/features/dictation/dictationBubble/store/useDictationStore';
import { useSessionRecordingStore } from '@/lib/audio/useSessionRecordingStore/useSessionRecordingStore';
import { getDictationBridgePort } from '@heidi/dictate';
import { isTauri } from '@heidi/runtime/platform';
import { type Editor as TiptapEditor } from '@tiptap/react';

export type UniversalDictationToggleResult = 'started' | 'stopped' | 'ignored';

export const toggleUniversalDictationFromEditor = (
  editor: TiptapEditor | null
): UniversalDictationToggleResult => {
  const dictationState = useDictationStore.getState();
  const isListening =
    dictationState.status === 'LISTENING' && dictationState.source === 'webDictateButton';

  if (isListening) {
    if (isTauri()) {
      void getDictationBridgePort().stopNativeDictation();
    } else {
      void dictationState.stop();
    }
    return 'stopped';
  }

  const isUniversalDictationActive =
    dictationState.status === 'LISTENING' || dictationState.status === 'PROCESSING';
  const isSessionRecording = useSessionRecordingStore.getState().status === 'RECORDING';

  if (
    isUniversalDictationActive ||
    isSessionRecording ||
    dictationState.nativeDictationActive
  ) {
    return 'ignored';
  }

  dictationState.setEditor(editor ?? null);
  editor?.commands.focus();
  dictationState.setDictationMode('HANDSFREE');
  dictationState.setSource('webDictateButton');

  if (isTauri()) {
    void getDictationBridgePort().startProgrammaticDictation();
  } else {
    void dictationState.start();
  }

  return 'started';
};
